const offerteInit = () => {
  const offerteFormFooter = document.querySelector('.offerte .gform_wrapper .gform_footer');
  const offerteFormFields = document.querySelector('.offerte .gform_wrapper form .gform_fields');
  offerteFormFields?.insertAdjacentElement('beforeend', offerteFormFooter);
};

export default offerteInit;
